import { useApi } from 'api/api-context';
import { DataMultiSelect, DataMultiSelectInheritedProps } from 'components/selects/DataSelect';
import { useCallback } from 'react';

export interface HrPersonSelectOption {
  value: number;
  label: string;
  group?: string;
  organizationId: number;
}

/** Authoritative multi-person selector limited to active people manageable by the actor. */
export default function HrPersonMultiSelect(props: DataMultiSelectInheritedProps) {
  const { getAction } = useApi();
  const fetchPeople = useCallback(async (): Promise<HrPersonSelectOption[]> => {
    const people = await getAction('HrListPeople')({ query: { filters: { includeInactive: false } } });
    return people
      .filter((person) => person.actionPermissions.manageTerms)
      .map((person) => ({
        value: person.personId,
        label: `${person.firstName} ${person.lastName}`.trim(),
        group: person.organizationName,
        organizationId: person.organizationId,
      }));
  }, [getAction]);

  return <DataMultiSelect action={fetchPeople} valueProp="value" labelProp="label" groupProp="group" {...props} />;
}
